export const featureFlags = {
  agentCommandCentre: 'agent-command-centre',
  sourcing: 'sourcing',
  linkedinSso: 'linkedin-sso',
  prescreenEmailCollection: 'prescreen-email-collection',
  newCoordinationAgentSettings: 'new-coordination-agent-settings',
  googleCalendar: 'google-calendar',
} as const;

export type FeatureFlags = keyof typeof featureFlags;
